export enum DestinationTypes{
    Parking = 2
}
